import React, { Component } from "react";    
import {connect} from "react-redux"; 
import { withTranslation } from 'react-i18next';

class MaintainGochiKid extends Component {
    render() {
      const { t } = this.props;
      return (
        <div className="shop-not-avai text-center">
          {/* <img src={require('../../../assets/img/icons/gochi_logo_print.png')}
               alt={t('other.This feast button cannot be used because the store is not open')}
               width="100%"
               className="image-not-available"
          /> */}

          <div className="text-left fs-16">
            【ご案内】10/2 15:00-17:00はメンテナンスのためこどもごちめしのご利用・ご支援ができませんのでご注意ください。
          </div>

          <a
            className="btn btn-green-38 align-center mt-3"
            href="/mypage"
          >
            マイページへ戻る
          </a>
        </div>
      );
    }
}
const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MaintainGochiKid));

